import React from "react";

import styled from "styled-components";

import Dropdown from "components/atoms/Dropdown";
import Icon from "components/atoms/Icon";
import Tooltip from "components/atoms/Tooltip";
import { toolbarCommands } from "components/organisms/manuscript/editor/commands";

const SymbolPopover = styled.div`
    padding: 8px;
    border: 1px solid #d8e1ec;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.12);
`;

const SymbolHeader = styled.div`
    margin-bottom: 8px;
    color: #42576b;
    font-size: 11px;
    font-weight: 700;
`;

const SymbolGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 6px;
    min-width: 232px;
`;

const SymbolButton = styled.button`
    display: grid;
    gap: 2px;
    align-items: center;
    justify-items: center;
    min-height: 52px;
    padding: 8px 6px;
    border: 1px solid #d9e2ec;
    border-radius: 8px;
    background: #ffffff;
    color: #42576b;
    cursor: pointer;

    &:hover {
        background: #f8fbfd;
        border-color: #bfcddd;
    }
`;

const SymbolGlyph = styled.div`
    color: #17314a;
    font-size: 15px;
    font-weight: 700;
    line-height: 1;
`;

const SymbolLabel = styled.div`
    color: #6c8196;
    font-size: 10px;
    font-weight: 600;
    line-height: 1;
`;

const COMMON_SYMBOLS = [
    { glyph: "α", label: "alpha", command: "\\alpha" },
    { glyph: "β", label: "beta", command: "\\beta" },
    { glyph: "γ", label: "gamma", command: "\\gamma" },
    { glyph: "Δ", label: "Delta", command: "\\Delta" },
    { glyph: "λ", label: "lambda", command: "\\lambda" },
    { glyph: "μ", label: "mu", command: "\\mu" },
    { glyph: "π", label: "pi", command: "\\pi" },
    { glyph: "σ", label: "sigma", command: "\\sigma" },
    { glyph: "≤", label: "leq", command: "\\leq" },
    { glyph: "≥", label: "geq", command: "\\geq" },
    { glyph: "≠", label: "neq", command: "\\neq" },
    { glyph: "∞", label: "infty", command: "\\infty" },
];

function ManuscriptSymbolDropdown({
    Button,
    disabled,
    iconColor,
    runEditorCommand,
    open,
    onOpenChange,
    dropdownUsePortal = true,
}) {
    const handleInsert = (command) => {
        onOpenChange(false);
        runEditorCommand((view) => toolbarCommands.insertSymbol(view, command));
    };

    return (
        <Tooltip message="기호">
            <Dropdown
                open={open}
                onOpenChange={onOpenChange}
                placement="bottom-start"
                offset={6}
                anchor={
                    <Button
                        type="button"
                        onMouseDown={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                        }}
                        onClick={() => {
                            if (disabled) return;
                            onOpenChange(!open);
                        }}
                        disabled={disabled}
                        aria-label="기호 삽입"
                    >
                        <Icon name={"alpha"} size={"12px"} color={iconColor} />
                    </Button>
                }
                contentMinWidth="248px"
                usePortal={dropdownUsePortal}
            >
                <SymbolPopover>
                    <SymbolHeader>자주 쓰는 기호</SymbolHeader>
                    <SymbolGrid>
                        {COMMON_SYMBOLS.map((symbol) => (
                            <SymbolButton
                                key={symbol.command}
                                type="button"
                                onClick={() => handleInsert(symbol.command)}
                                aria-label={`${symbol.label} 삽입`}
                            >
                                <SymbolGlyph>{symbol.glyph}</SymbolGlyph>
                                <SymbolLabel>{symbol.label}</SymbolLabel>
                            </SymbolButton>
                        ))}
                    </SymbolGrid>
                </SymbolPopover>
            </Dropdown>
        </Tooltip>
    );
}

export default React.memo(ManuscriptSymbolDropdown);
